import screen from './List';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/List/index.js